import { createContext } from 'react';
var CheckboxCheckedContext = /*#__PURE__*/createContext(false);
export { CheckboxCheckedContext as C };